export class Role {
    constructor(
        public id?: number,
        public description?: string,
        public name?: string
    ) {

    }

}